import React from 'react';
import { Link } from 'react-router-dom';
import SecondaryHeading from "../SecondaryHeading/SecondaryHeading";
import TotalValue from "../TotalValue/TotalValue";
import './ChartComplex.styles.scss';
// import { getClassName } from "../../core/helpers";
//
// const columns = [
//     'other',
//     'delivery service',
//     'brought by peer',
//     'went elsewhere',
//     'had food on-hand',
// ];

const ChartComplex = ({ name, items, rowColor = '', maxValue }) => {
    return (
        <div className="chart-complex">

            <div className="chart-complex__category-title">
                <SecondaryHeading>
                    {name}
                </SecondaryHeading>
            </div>

            <div className="chart-complex__inner">
                <div className="chart-complex__body">
                    {items.map((item, inx) => (
                        <div className={`chart-complex__row chart-complex__row--${rowColor}`} key={inx}>
                            <div className="chart-complex__subcategory chart__col chart__col-3">
                                {item.link ? (
                                    <Link
                                        to={item.link}
                                        className="chart-complex__subcategory-title"
                                    >
                                        {item.name}
                                    </Link>
                                ) : (
                                    <div className="chart-complex__subcategory-title">
                                        {item.name}
                                    </div>
                                )}
                            </div>
                            <div className="chart-complex__subcategory chart__col chart__col-4">
                                <div
                                    className="chart-complex__bar-line-wrap"
                                >
                                    <div
                                        className={`chart-complex__bar-line ${item.value === 100 ? 'selected-bar' : ''}`}
                                        style={{ width: `${((Math.min(item.value, maxValue)) / maxValue) * 100}%` }}
                                    >
                                        <div className="chart-complex__bar-line-value">{item.value}%</div>
                                    </div>
                                    {/*<div*/}
                                    {/*    className="chart-complex__bar-average-line"*/}
                                    {/*    style={{ left: `${((item.total) / maxValue) * 100}%` }}*/}
                                    {/*>*/}
                                    {/*    <TotalValue className="chart-complex__total-value">*/}
                                    {/*        {item.total}%*/}
                                    {/*    </TotalValue>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
};

export default ChartComplex;